// extracted by mini-css-extract-plugin
module.exports = {"link":"ForumLink_link__1XomG","main":"ForumLink_main__2_vvj","caret":"ForumLink_caret__3SqF5","load":"ForumLink_load__1e0-A"};